import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear all authentication data
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_info');
    
    // Clear any other session data
    sessionStorage.clear();
    
    // Redirect to login after a short delay
    setTimeout(() => {
      navigate('/login');
    }, 1200);
  }, [navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="h6">Logging out...</Typography>
    </Box>
  );
};

export default Logout; 